import React from "react";
import {hydrateRoot} from "react-dom/client";
import {loadableReady} from '@loadable/component';
import {dynamicImport, preloadComponent} from './app/helpers/common';
import QuestionnaireWidget from './app/widgets/questionnaire-widget';

const removeSSRStyles = () => {
    if (document.getElementById('jss-server-side')) {
        document.getElementById('jss-server-side').remove();
    }

    if (document.getElementById('jss-server-side-2')) {
        document.getElementById('jss-server-side-2').remove();
    }
};

if (document.getElementById('questionnaire-widget')) {
    const container = document.getElementById('questionnaire-widget');

    loadableReady(() => {
        const Questionnaire = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Home" */ './app/views/app/Questionnaire'));
        Questionnaire.load().then(() => {
            removeSSRStyles();
            hydrateRoot(container, <QuestionnaireWidget location={window.location.pathname} />);
        });
    });
}

